import { ChangeDetectorRef, Component, Input, NgZone, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { AgCharts } from "ag-charts-angular";
import {
  AgCartesianAxisOptions,
} from "ag-charts-community";
import clone from "clone";
import { NgxSpinnerService } from 'ngx-spinner';
import { SearchService } from '../../shared/services/search.service';






@Component({
  selector: 'app-mta-mtf',
  standalone: true,
  imports: [AgCharts],
  templateUrl: './mta-mtf.component.html',
  styleUrl: './mta-mtf.component.scss'
})
export class MtaMtfComponent implements OnInit, OnChanges {
  bardata: any
  @Input() orderPost: any;
  public options: any;
  graphData: any = []

  constructor(private _searchService: SearchService, private ngZone: NgZone, private spinner: NgxSpinnerService, private cd: ChangeDetectorRef) {

  }
  ngOnInit(): void {
    // throw new Error('Method not implemented.');

  }
  ngOnChanges(changes: SimpleChanges): void {
    if (this.orderPost.customerReference) {
      this.ngZone.run(() => {
        this.getQunatityStatusData();
      });

    }
     this.cd.detectChanges();
  }
  getQunatityStatusData() {
    this.graphData = [];
this.spinner.show();
    this._searchService.getOdinQuantityStausData(this.orderPost.customerReference).subscribe((res: any) => {
      this.spinner.hide();
      res.content.forEach((element: any) => {
        if(element.salesOrderNumber==this.orderPost.salesOrderNumber){
 this.graphData = element.stockProjections;
        this.setGraph(this.graphData);
        return;
        }
       
      });
    },
      () => {
        this.spinner.hide();
        if (this.graphData?.length != 0) {
          // this.setGraph(this.graphData)
          this.ngOnInit()
        }
        //  this.setGraph(this.graphData)
        this.ngOnInit()
        // Optional: Execute a function when the Observable completes (success or error)
      });
    // this.ngZone.run(() => {
      // this.setGraph(this.graphData)
    // });

    this.cd.detectChanges()
  }


  getSymmetricRange(values: number[]): { min: number; max: number } {
  const min = Math.min(...values);
  const max = Math.max(...values);
  const absMax = Math.max(Math.abs(min), Math.abs(max));
  return { min: -absMax, max: absMax };
}

  setGraph(ValueforGraph: any) {
   
   const inflow = ValueforGraph.map((d: any) => d.inflowVolume);
const outflow = ValueforGraph.map((d: any) => d.outflowVolume);
const stock = ValueforGraph.map((d: any) => d.stockPosition);
const coverage = ValueforGraph.map((d: any) => d.weekCoverage);

 
  const volumeValues = [...inflow, ...outflow, ...stock];
  const volumeRange = this.getSymmetricRange(volumeValues);
  const coverageRange = this.getSymmetricRange(coverage);
   
    this.options = {
      data: ValueforGraph,
      title: {
        text: "MTA-MTF Data Flow",
      },
      series: [
        {
          "type": "bar",
          "xKey": "week",
          "yKey": "inflowVolume",
          "yName": "In FLow"
        },
        {
          "type": "bar",
          "xKey": "week",
          "yKey": "outflowVolume",
          "yName": "Out Flow"
        },
         {
      "type": "line",
      "xKey": "week",
      "yKey": "weekCoverage",
      "yName": "Week Coverage",
    },
        {
          "type": "bar",
          "xKey": "week",
          "yKey": "stockPosition",
          "yName": "Stocks"
        }
      ]
      ,
      axes: [
        {
          type: "category",
          position: "bottom",
          title:{
            text: "Weeks",
          }
        },
        {
          // primary y axis
          type: "number",
          position: "left",
          keys: ["inflowVolume", "outflowVolume", "stockPosition"],

          title: {
            text: "Volume",
          },
         min:volumeRange.min,
         max: volumeRange.max,
        
        },
        {
          // secondary y axis
          type: "number",
          position: "right",
            keys: ["weekCoverage"],
          title: {
            text: "Number of weeks covered",
          },
           min:coverageRange.min,
           max:coverageRange.max,
         
        },
      ] as AgCartesianAxisOptions[],
    };

  }
   setGraphOld(ValueforGraph: any) {


    this.options = {
      data: ValueforGraph,
      title: {
        text: "MTA-MTF Data Flow",
      },
      series: [
        {
          "type": "bar",
          "xKey": "week",
          "yKey": "inflowVolume",
          "yName": "In FLow"
        },
        {
          "type": "bar",
          "xKey": "week",
          "yKey": "outflowVolume",
          "yName": "Out Flow"
        },
         {
      "type": "line",
      "xKey": "week",
      "yKey": "weekCoverage",
      "yName": "Week Coverage",
    },
        {
          "type": "bar",
          "xKey": "week",
          "yKey": "stockPosition",
          "yName": "Stocks"
        }
      ]
      ,
      axes: [
        {
          type: "category",
          position: "bottom",
          title:{
            text: "Weeks",
          }
        },
        {
          // primary y axis
          type: "number",
          position: "left",
          keys: ["inflowVolume", "outflowVolume", "stockPosition"],

          title: {
            text: "Volume",
          },
        
        },
        {
          // secondary y axis
          type: "number",
          position: "right",
            keys: ["weekCoverage"],
          title: {
            text: "Number of weeks covered",
          },
         
        },
      ] as AgCartesianAxisOptions[],
    };

  }
  
 
  barLine = () => {
    const options = clone(this.options);

    options.series = [
      {
        "type": "bar",
        "xKey": "week",
        "yKey": "inflowVolume",
        "yName": "In FLow"
      },
      {
        "type": "bar",
        "xKey": "week",
        "yKey": "outflowVolume",
        "yName": "Out Flow"
      },
      {
        "type": "bar",
        "xKey": "week",
        "yKey": "stockPosition",
        "yName": "Stocks"
      }
    ];

    this.options = options;
  };

 
}
